"use client";

import Link from "next/link";
import { Button } from "@/components/ui/button";
import { useSignedIn } from "@/lib/auth/auth-hint";

/** The button on a pack card: new visitors start free; signed-in people go to the page where they can buy. */
export function PackCta({ best }: { best: boolean }) {
	const user = useSignedIn();
	return (
		<Button asChild variant={best ? "default" : "outline"} className="mt-auto min-h-11">
			{user ? <Link href="/credits" data-testid="pack-buy">Buy credits</Link> : <Link href="/login">Get started</Link>}
		</Button>
	);
}
